import { type LucideIcon, Monitor, Moon, Sun } from 'lucide-react';

import { THEME, type Theme } from '@nesso/ui/lib/theme';
import { ToggleGroup } from '@nesso/ui/primitives/toggle-group';
import { TooltipProvider } from '@nesso/ui/primitives/tooltip';

import { UserDropdownThemeToggleButton } from './user-dropdown-theme-selector/user-dropdown-theme-toggle-button';

interface ThemeSelectorProps {
    theme: string;
    onThemeChange: (value: string) => void;
}

const themeOptions: readonly {
    value: Theme;
    label: string;
    icon: LucideIcon;
}[] = [
    {
        value: THEME.LIGHT,
        label: 'Light',
        icon: Sun,
    },
    {
        value: THEME.DARK,
        label: 'Dark',
        icon: Moon,
    },
    {
        value: THEME.SYSTEM,
        label: 'System',
        icon: Monitor,
    },
] as const;

export function UserDropdownThemeSelector({ theme, onThemeChange }: ThemeSelectorProps) {
    return (
        <div className="flex items-center justify-between pl-2 pr-2 py-0">
            <span className="pl-1">Theme</span>
            <ToggleGroup
                type="single"
                value={theme}
                onValueChange={onThemeChange}
                aria-label="Theme selector"
                className="bg-background/90 gap-1 p-1 rounded-sm"
            >
                <TooltipProvider>
                    {themeOptions.map((option) => (
                        <UserDropdownThemeToggleButton
                            key={option.value}
                            value={option.value}
                            label={option.label}
                            icon={option.icon}
                            isSelected={theme === option.value}
                        />
                    ))}
                </TooltipProvider>
            </ToggleGroup>
        </div>
    );
}
